import {ThemeColourModuleConfiguration} from "./ThemeColourSelectModuleConfiguration";
import {
    MultiHueColourSelectComponent
} from "./component/hue_colour_select/multi_hue_colour_select/multi-hue-colour-select.component";
import {
    SingleHueColourSelectComponent
} from "./component/hue_colour_select/single_hue_colour_select/single-hue-colour-select.component";

ThemeColourModuleConfiguration
    .createNewModule()
    .component('themeColourPicker', MultiHueColourSelectComponent.instance)
    .component('singleHueColourPicker', SingleHueColourSelectComponent.instance);